module.exports = __webpack_public_path__ + "./Billy_pbw_d20a68c3b9a348354ee13bb9238ed9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Billy_pbw.png
// module id = 613
// module chunks = 0